/* =========================================================
   CHAGUAL – PLP "· N medidas" (repair layer)
   - Respeta el contrato server-side de medidas
   - Restaura texto/visibilidad cuando un re-render externo borra el target
   - Ya no calcula la verdad primaria del count vía fetch
   ========================================================= */
/* GUARDRAIL: repair layer de medidas; no convertir este archivo en verdad primaria del count ni en owner funcional del card. Leer 08, 09 y 10 antes de tocar; si el cambio mueve autoridad, abrir lote nuevo. */

(function () {
  const DEBUG = false;
  const log = (...args) => DEBUG && console.log("[PLP-SIZES]", ...args);

  function readInt(...values) {
    for (const value of values) {
      const n = Number(value);
      if (Number.isFinite(n)) return n;
    }
    return 0;
  }

  function getSizeTarget(card) {
    if (!card || card.nodeType !== 1) return null;
    return card.querySelector("[data-plp-size-count]");
  }

  function getSizeShell(target) {
    if (!target || !target.parentElement) return null;
    return target.parentElement;
  }
  function getFallbackCount(card, target) {
    return readInt(
      target && target.getAttribute("data-size-count-fallback"),
      card && card.getAttribute("data-size-count-fallback"),
      0
    );
  }

  function getDeclaredVisibility(card, target) {
    const shell = getSizeShell(target);
    const targetState = (target && target.getAttribute("data-size-count-state") || "").trim();
    const shellState = (shell && shell.getAttribute("data-size-count-state") || "").trim();
    const cardState = (card && card.getAttribute("data-size-count-state") || "").trim();
    const hasSizeCount = (card && card.getAttribute("data-has-size-count") || "").trim();

    if (targetState === "visible" || shellState === "visible" || cardState === "visible") return "visible";
    if (targetState === "hidden" || shellState === "hidden" || cardState === "hidden") return "hidden";
    if (hasSizeCount === "true") return "visible";
    if (hasSizeCount === "false") return "hidden";
    return "unknown";
  }

  function markVisible(card, target, textValue) {
    if (!card || !target || !textValue) return;

    target.hidden = false;
    if (target.textContent !== textValue) {
      target.textContent = textValue;
    }
    target.removeAttribute("aria-hidden");
    target.setAttribute("data-size-count-state", "visible");
    ["display", "margin", "padding", "height", "min-height", "border", "background"].forEach((prop) => {
      target.style.removeProperty(prop);
    });

    const shell = getSizeShell(target);
    if (shell) {
      shell.hidden = false;
      shell.removeAttribute("hidden");
      shell.removeAttribute("aria-hidden");
      shell.setAttribute("data-size-count-state", "visible");
      ["display", "margin", "padding"].forEach((prop) => shell.style.removeProperty(prop));
    }

    card.setAttribute("data-has-size-count", "true");
    card.setAttribute("data-size-count-state", "visible");
    card.dataset.plpSizesState = "done";
  }

  function markHidden(card, target) {
    if (!card || !target) return;

    target.hidden = true;
    if (target.textContent !== "") {
      target.textContent = "";
    }
    target.setAttribute("aria-hidden", "true");
    target.setAttribute("data-size-count-state", "hidden");
    target.style.setProperty("display", "none", "important");
    target.style.setProperty("margin", "0", "important");
    target.style.setProperty("padding", "0", "important");
    target.style.setProperty("height", "0", "important");
    target.style.setProperty("min-height", "0", "important");
    target.style.setProperty("border", "0", "important");
    target.style.setProperty("background", "transparent", "important");

    const shell = getSizeShell(target);
    if (shell && (shell.classList.contains("product-meta-line") || shell.classList.contains("ch-sale-meta"))) {
      shell.hidden = true;
      shell.setAttribute("hidden", "hidden");
      shell.setAttribute("aria-hidden", "true");
      shell.setAttribute("data-size-count-state", "hidden");
      shell.style.setProperty("display", "none", "important");
      shell.style.setProperty("margin", "0", "important");
      shell.style.setProperty("padding", "0", "important");
    }

    card.setAttribute("data-has-size-count", "false");
    card.setAttribute("data-size-count-state", "hidden");
    card.dataset.plpSizesState = "done";
  }

  function syncCard(card, reason) {
    if (!card || card.nodeType !== 1) return;

    const target = getSizeTarget(card);
    if (!target) {
      card.dataset.plpSizesState = "done";
      return;
    }

    const fallbackCount = getFallbackCount(card, target);
    const declaredVisibility = getDeclaredVisibility(card, target);
    const currentText = (target.textContent || "").replace(/\s+/g, " ").trim();

    let shouldShow = false;
    if (declaredVisibility === "visible") shouldShow = true;
    else if (declaredVisibility === "unknown" && fallbackCount > 1) shouldShow = true;

    if (shouldShow) {
      const textValue = fallbackCount > 1 ? `${fallbackCount} medidas` : currentText;
      if (textValue) {
        markVisible(card, target, textValue);
      } else {
        card.dataset.plpSizesState = "stale";
        log("visible contract without text/fallback", reason, card);
      }
    } else {
      markHidden(card, target);
    }

    card.setAttribute("data-plp-sizes-tried-at", String(Date.now()));
    card.setAttribute("data-plp-sizes-last-sync-reason", reason || "boot");
  }

  function collectCards(root) {
    const scope = root && root.nodeType === 1 ? root : document;
    const list = [];

    if (scope.matches && scope.matches("[data-plp-card]")) {
      list.push(scope);
    }

    if (scope.querySelectorAll) {
      list.push(...scope.querySelectorAll("[data-plp-card]"));
    }

    return list;
  }

  function syncCards(root, reason) {
    const cards = collectCards(root);
    for (const card of cards) syncCard(card, reason);
  }

  let bootScheduled = false;
  let pendingBootRoot = document;
  let pendingBootReason = "boot";

  function scheduleBoot(root = document, reason = "boot") {
    pendingBootRoot = root && root.nodeType === 1 ? root : document;
    if (reason === "mutation" || pendingBootReason !== "mutation") {
      pendingBootReason = reason;
    }
    if (bootScheduled) return;
    bootScheduled = true;
    requestAnimationFrame(() => {
      bootScheduled = false;
      const nextRoot = pendingBootRoot;
      const nextReason = pendingBootReason;
      pendingBootRoot = document;
      pendingBootReason = "boot";
      syncCards(nextRoot, nextReason);
    });
  }

  function mutationTouchesSizeContract(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches("[data-plp-card], [data-plp-size-count], [data-size-count-wrapper], .product-details, .ch-sale-meta, .product-meta-line")) {
      return true;
    }
    return !!node.querySelector("[data-plp-card], [data-plp-size-count], [data-size-count-wrapper]");
  }

  window.ChagualPLPSizes = {
    rerun() {
      scheduleBoot(document, "manual");
    },
  };

  scheduleBoot(document, "boot");

  document.addEventListener("DOMContentLoaded", () => scheduleBoot(document, "boot"));
  window.addEventListener("load", () => scheduleBoot(document, "boot"));
  window.addEventListener("pageshow", () => scheduleBoot(document, "boot"));

  document.addEventListener("turbo:load", () => scheduleBoot(document, "boot"));
  document.addEventListener("turbo:render", () => scheduleBoot(document, "boot"));
  document.addEventListener("page:load", () => scheduleBoot(document, "boot"));
  document.addEventListener("page:change", () => scheduleBoot(document, "boot"));

  const obs = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const el = mutation.target && mutation.target.nodeType === 1
        ? mutation.target
        : mutation.target && mutation.target.nodeType === 3
        ? mutation.target.parentElement
        : null;

      if (mutationTouchesSizeContract(el)) {
        scheduleBoot(el.closest && el.closest("[data-plp-card]") || document, "mutation");
        return;
      }

      for (const node of mutation.addedNodes) {
        if (mutationTouchesSizeContract(node)) {
          const root = node.closest && node.closest("[data-plp-card]") || node;
          scheduleBoot(root, "mutation");
          return;
        }
      }
    }
  });

  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    }, { once: true });
  }
})();
